module.exports = __webpack_public_path__ + "static/img/14k.9aed2ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/14k.jpg
// module id = HIq4
// module chunks = 0